  export class Precompra {
    constructor(
      public idusuario: string,
      public idempresa: string,
      public refenciapaypal: string,
      public concepto: string,
      public clicencia: number,
      public emailempresa: string,
      public totalpagado : number,
      public inventariototal : number,
      public disponibilidad : number,
      public tipolicencias?: string



     ) { }
  }


